import compact from 'lodash/compact';
import filter from 'lodash/filter';
import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import map from 'lodash/map';

import initialState from './initialState';

import {
  ANSWER_FETCH_SUCCESS,
  ANSWER_UPDATE_SEARCH_RESULTS,
  ANSWER_UPDATE_SELECTED_ANSWER,
  ANSWER_CLEAR_SEARCH_RESULTS,
} from 'app/modules/knowledge_base/demo/constants';

export default function knowledgeBaseReducer(state = {}, action) {
  let { type, payload } = action;
  switch (type) {
    case ANSWER_FETCH_SUCCESS:
      return {
        ...state,
        byId: translateAnswersById(payload.answers),
        allIds: allAnswerIds(payload.answers),
        suggestedAnswerIds: payload.suggestedAnswerIds,
        searchResultAnswerIds: [],
        selectedResultAnswerId: '',
      };
    case ANSWER_UPDATE_SEARCH_RESULTS:
      return {
        ...state,
        searchResultAnswerIds: payload.searchResultAnswerIds,
      };
    case ANSWER_UPDATE_SELECTED_ANSWER:
      return {
        ...state,
        selectedResultAnswerId: payload.selectedResultAnswerId,
      };
    case ANSWER_CLEAR_SEARCH_RESULTS:
      return {
        ...state,
        searchResultAnswerIds: [],
      };
    default:
      return state;
  }
}

function filterByPublicAnswer(answers) {
  return filter(answers, function(answer) {
    return get(answer, 'content.public');
  });
}

const translateAnswersById = answers => {
  return keyBy(answers, 'id');
};

const allAnswerIds = answers => {
  return map(answers, 'id');
};

/*
 * answer list selectors
 */
export const getAnswers = state => {
  return compact(state.allIds.map(id => getAnswerById(state, id)));
};

export const getSuggestedAnswers = state => {
  return compact(state.suggestedAnswerIds.map(id => getAnswerById(state, id)));
};

export const getKBSearchResults = state => {
  return compact(state.searchResultAnswerIds.map(id => getAnswerById(state, id)));
};

/*
 * actions
 */

export function fetchAnswersSuccess({ answers, suggestedAnswerIds }) {
  return {
    type: ANSWER_FETCH_SUCCESS,
    payload: {
      answers: filterByPublicAnswer(answers),
      suggestedAnswerIds,
    },
  };
}

export function updateKBSearchResults({ searchResultAnswerIds }) {
  return {
    type: ANSWER_UPDATE_SEARCH_RESULTS,
    payload: {
      searchResultAnswerIds,
    },
  };
}

export function updateSelectedAnswer({ selectedResultAnswerId }) {
  return {
    type: ANSWER_UPDATE_SELECTED_ANSWER,
    payload: {
      selectedResultAnswerId,
    },
  };
}

export function clearKBSearchResults() {
  return {
    type: ANSWER_CLEAR_SEARCH_RESULTS,
  };
}

/*
 * single answer selectors
 */

export const getAnswerById = (state, id) => {
  const answer = state.byId[id];
  if (!answer) {
    return null;
  }
  return answer;
};

export const getSelectedAnswer = state => {
  return state.byId[state.selectedResultAnswerId];
};

export { initialState };
